export const actions = {
  SET_STATE: 'menu/SET_STATE',
  GET_DATA: 'menu/GET_DATA',
}

export const getListadoMenuByUsuarioIdAction = (dispatch, usuarioId) => {
  dispatch({
    type: actions.GET_DATA,
    payload: usuarioId,
  })
}
